"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function InvitationAcceptIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M7.473,4.787c.317.077.629.171.943.266a7.433,7.433,0,0,0,1.813.394,3.466,3.466,0,0,0,1.739-.415,4.938,4.938,0,0,0-8.581-.271A9.164,9.164,0,0,1,7.473,4.787Z" }),
        react_1.default.createElement("path", { d: "M10.179,6.623a8.455,8.455,0,0,1-2.1-.444C7.783,6.091,7.49,6,7.2,5.93a8.032,8.032,0,0,0-4.391.2,4.975,4.975,0,1,0,9.6,0A4.624,4.624,0,0,1,10.179,6.623Z" }),
        react_1.default.createElement("path", { d: "M9.354,18.428a4.505,4.505,0,0,1,2.393-3.968,7.02,7.02,0,0,0-2.684-.522H6.146C3.023,13.938.468,15.9.468,18.3v.953a13.127,13.127,0,0,0,7.316,1.92,15.142,15.142,0,0,0,2.362-.192A4.5,4.5,0,0,1,9.354,18.428Z" }),
        react_1.default.createElement("path", { d: "M16.083,21.6h0a.849.849,0,0,1-.6-.249l-3.5-3.506,1.2-1.2,2.9,2.9L22.331,13.3l1.2,1.2-6.848,6.848A.846.846,0,0,1,16.083,21.6Z" })));
}
exports.default = InvitationAcceptIcon;
